<template>

    <!--答题页面-->
    <div class="container-head-top">
        <!--人格测试end-->
        <div class="personality" v-show="!loading">

            <!--兴趣测试start-->
            <div class="topic">
                <div class="testHead">
                    <h1 class="mrgB5">{{TestDetail.title}}</h1>
                    <p>{{TestDetail.testTimesStr}}&nbsp;&nbsp;&nbsp;&nbsp;发布于{{TestDetail.createdAt}}</p>
                    <p class="number"><span class="inline-block">共 {{TestDetail.itemCount}} 题</span></p>
                </div>
                <div class="progress_bar">
                    <div style="text-align: right;font-size: 15px;">
                        {{currentPage+1}}/{{this.TestOptions.length}}
                    </div>

                    <span style="width:89%;">
                        <el-progress :percentage="percentage" :format="format" :show-text="false"></el-progress>
                    </span>

                </div>
                <div>

                    <el-collapse-transition>


                        <div v-show="controllerTopicShow" class="ticontent" v-for="(valueCD,indexct) in  dataShow" :key="indexct">
                            <div>
                                {{valueCD.itemTitle}}
                            </div>
                            <div v-for="(danxuan,indexOne) in valueCD.optionsList" :key="indexOne" class="ticontent-input">
                                <label class="settingBtnStyle" :for="currentPage+danxuan.optionId"
                                       @click.prevent="increase();otherincrease();nextPage(String(valueCD.itemId),String(danxuan.optionId),Number(danxuan.score))">
                                    <input type="radio"  :name="currentPage+danxuan.optionId" :checked="danxuan.optionId===zhiRadio" >
                                    {{danxuan.optionContent}}

                                </label>
                                <!--                                <el-radio v-model="itemSon.value" @change="nextPage(String(valueCD.no), TestOptions)" :label="itemSon.content"> </el-radio>-->


                            </div>
                            <!--<div class="upDownTest">-->
                                <!--&lt;!&ndash;上一题   下一题&ndash;&gt;-->
                                <!--<span v-if="upTest===valueCD.isStart" @click="prePage()">-->
                                         <!--上一题-->
                                     <!--</span>-->

                            <!--</div>-->
                        </div>

                    </el-collapse-transition>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    // fade/zoom 等
    import 'element-ui/lib/theme-chalk/base.css';
    import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
    import Vue from 'vue'

    Vue.component(CollapseTransition.name, CollapseTransition);

    import{
        soulTestDetail,
        soulTestOptions,
    } from '../../../config/index'
    export default {
        name: "heartTestData",
        data() {
            return {
                upTest:false,
                downTest:false,
                //控制当前页面是否在生成报告中
                loading: false,
                //监听内容每做完一题加一
                listenTopic: 0,
                zhiRadio: null,
                //控制题目显示，消失
                controllerTopicShow: true,
                show: false,
                //当前进入副页后当前所显示的内容
                intoDQContent: [],
                //单选选中
                radiocheck: '',
                //题目类型编号
                record_id: '',
                //页面容量
                pageSize: 1,
                //当前页
                currentPage: 0,
                daohangname: '',
                customColor: '#409eff',
                percentage: 1,
                colors: [
                    {color: '#f56c6c', percentage: 20},
                    {color: '#e6a23c', percentage: 40},
                    {color: '#5cb87a', percentage: 60},
                    {color: '#1989fa', percentage: 80},
                    {color: '#6f7ad3', percentage: 100}
                ],
                //放置题目的选项内容
                allTopicOptions: new Map(),
                TestDetail:[],
                TestOptions:[],
                NewScore:0,
            }
        },
        computed: {
             dataShow() {
                let start = this.currentPage * this.pageSize;
                let end = Math.min((this.currentPage + 1) * this.pageSize, this.TestOptions.length)
                return this.TestOptions.slice(start, end)
            },
            pageNum() {
                return Math.ceil(this.TestOptions.length / this.pageSize) || 1;
            },

        },
        mounted(){
            this.Id = this.$route.query.id;
            this.getTestDetail(this.Id);
            this.getTestOptions(this.Id);
        },
        methods: {
            prePage: function () {
                let vm = this;
                if (vm.currentPage === 0) return;
                vm.currentPage--;
            },
            async nextPage(t, s, xuanxiang) {
                this.zhiRadio = s;

                this.preStore = xuanxiang;
                let zx = setTimeout(async () => {
                    this.controllerTopicShow = false;

                    function MapTOJson(m) {
                        var str = '{';
                        var i = 1;
                        m.forEach(function (item, key, mapObj) {
                            if (mapObj.size === i) {
                                str += '"' + String(key) + '":' + item + '';
                            } else {
                                str += '"' + String(key) + '":' + item + ',';
                            }
                            i++;
                        });
                        str += '}';
                        return str;
                    }

                    this.allTopicOptions.set(t, s,xuanxiang);
                    let xx = setTimeout(async () => {
                        this.zhiRadio = null;
                        this.currentPage++;
                        this.listenTopic += 1;
                        this.controllerTopicShow = true;
                        clearTimeout(xx);
                        if (this.listenTopic === this.TestOptions.length) {
                            this.loading = true;
                            if (this.listenTopic < this.TestOptions.length) return;
                            //最后一题提交全部题目
                            this.$router.push(
                                {path:'/studentAndTeacherPlatform/heartImprove/heartTestResult',
                                query:{score:this.NewScore,id: this.Id }})



                        }
                    }, 500);
                    clearTimeout(zx);
                }, 100)

                this.NewScore += xuanxiang;

            },
            increase() {

                // if (this.$route.query.name === '2' || this.$route.query.name === 2) {
                //     this.percentage += 2.5;
                // } else if (this.$route.query.name === '1' || this.$route.query.name === 1) {
                //     this.percentage += 1.66;
                // } else if (this.$route.query.name === '6' || this.$route.query.name === 6) {
                //     this.percentage += 1;
                // } else if (this.$route.query.name === '3' || this.$route.query.name === 3) {
                //     this.percentage += 1.66;
                // } else if (this.$route.query.name === '4' || this.$route.query.name === 4) {
                //     this.percentage += 2.5;
                // } else {
                //     this.percentage += 1;
                // }
                if (this.percentage === 0) {
                    this.percentage = 0;
                }
                if (this.percentage<100){
                    this.percentage += (1 / this.TestOptions.length)*100;
                }

                if (this.percentage > 100) {
                    this.percentage = 100;
                }
                if (this.percentage === 100) {
                    this.percentage = 100;
                }
            },
            otherincrease() {
                this.format()
            },
            //进度条循环操作
            format(percentage) {
                let zhi = 0;
                for (let i = 0; i < this.TestOptions.length; i++) {
                    zhi++;
                    if (percentage === i + 1) {
                        return percentage === i + 1 ? (zhi) + `/${this.TestOptions.length}` : ``;
                    }
                }
            },
            //获取内容
            async getTestDetail(val){
                let res = await soulTestDetail(val);
                if (res.status){
                    this.TestDetail = res.data;

                }
            },
            //获取选项
            async getTestOptions(val){
                let res  = await soulTestOptions(val);
                if (res.status){
                    this.TestOptions = res.data;

                }
            },
        }

    }
</script>

<style scoped lang="scss">
    .container-head-top {
        width: 100%;
        height: 100%;
    }

    .personality {
        text-align: left;
        width: 1200px;
        margin: 0 auto;

    }

    /*设置按钮样式*/
    .settingBtnStyle {
        display: inline-block;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding-left: 20px;
    }

    .settingBtnStyle:hover {
        background: #fff3e0;
        cursor: pointer;
    }

    .personality .backmenu {
        border-bottom: solid 1px #e2e2e2;
        padding-bottom: 15px;
    }

    .personality .backmenu a, span {
        font-size: 13px;
        color: #666;
    }

    .personality .backmenu a:hover {
        color: #2db7f5;
    }

    .personality .topic {

        font-size: 18px;
        background: #fff;
        padding: 35px 80px;

        .testHead {
            text-align: center;
            line-height: 200%;
            color: #999;
            font-size: 14px;
            margin-bottom: 40px;

            h1 {
                font-size: 24px;
                color: #333;
                line-height: 35px;
            }

            .number {
                border-top: 1px solid #eee;
                margin-top: 25px;

                span {
                    width: 83px;
                    height: 32px;
                    line-height: 32px;
                    border: 1px solid #eee;
                    border-radius: 4px;
                    position: relative;
                    top: -17px;
                    background-color: #fff;
                }
            }
        }
    }

    .ticontent {
        margin-top: 20px;
    }

    .ticontent-input {
        margin: 20px 10px;
    }
    .upDownTest{
        width: max-content;
        margin: 0 auto;
        cursor: pointer;
        span{
            margin: 15px;
        }
    }
</style>
